import { render, staticRenderFns } from "./SvgComponents.vue?vue&type=template&id=24a983c9&"
import script from "./SvgComponents.vue?vue&type=script&lang=js&"
export * from "./SvgComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports